import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MDButton from "./MDButton";

const ConfirmDialog = (props) => {
  const { title, children, open, setOpen, onConfirm } = props;
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="confirm-dialog"
    >
      <DialogTitle id="confirm-dialog">{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <MDButton
          variant="contained"
          onClick={() => setOpen(false)}
          color="secondary"
        >
          Não
        </MDButton>
        <MDButton
          variant="contained"
          onClick={() => {
            setOpen(false);
            onConfirm();
          }}
          color="info"
        >
          Sim
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;